export default {
  outbound: 'Utreise',
  inbound: 'Retur',
  hide: 'Gjemme seg',
  details: 'Detaljer',
}
